import clsx from 'clsx';
import React from 'react';

import { getProviderCapabilities, PROVIDER_AGENT, ProviderId } from '../../entities/provider';

interface AgentSwitcherProps {
  /** The platform the wizard actually built the project on. */
  builtPlatform: ProviderId;
  /** Currently effective agent name (e.g. 'WizardAgent' or 'JiraAgentV2'). */
  activeAgent: string;
  onChange: (agent: string) => void;
  className?: string;
}

// Offered once a Wizard proposal has been built — WizardAgent's job (propose + build) is done at
// that point, so continuing to chat with it is rarely what the user wants. Lets them switch to
// the specialist agent for whichever platform the project actually landed on, or back to Wizard
// if they still want to talk about the original spec.
export const AgentSwitcher: React.FC<AgentSwitcherProps> = ({ builtPlatform, activeAgent, onChange, className }) => {
  const platformAgent = PROVIDER_AGENT[builtPlatform];
  const platformLabel = getProviderCapabilities(builtPlatform).label;

  const optionClass = (isActive: boolean) =>
    clsx(
      'px-2.5 py-1 rounded-md text-xs transition',
      isActive
        ? 'bg-base-100 shadow-card font-medium text-base-content'
        : 'text-base-content/60 hover:text-base-content',
    );

  return (
    <div className={clsx('inline-flex items-center gap-1 rounded-lg bg-base-200 p-1', className)}>
      <span className="px-1.5 text-[10px] uppercase tracking-wide text-base-content/40">Agent</span>
      <button className={optionClass(activeAgent === 'WizardAgent')} onClick={() => onChange('WizardAgent')}>
        Wizard
      </button>
      <button className={optionClass(activeAgent === platformAgent)} onClick={() => onChange(platformAgent)}>
        {platformLabel}
      </button>
    </div>
  );
};

export default AgentSwitcher;
